<template>
  <div class="Hours_statistics">
    <el-container>
      <el-header>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="日期">
            <el-date-picker v-model="value1" value-format="yyyy-MM" type="month" placeholder="选择月">
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="chaxun">查询</el-button>
          </el-form-item>
        </el-form>
      </el-header>

      <el-main>
        <table style="width: 100%">

                    <div class="details">

            <table style="width: 100%;float: left;">

              <tr>
                <td v-for="(item,i) in options" :key="i">{{item.dropKeyContent}}</td>
              </tr>

              
              <tr>
                <td v-for="(itmes,j) in alldata" :key="j">
                  <table>
                    <tr>
                      <td colspan="1" style="width: 80px;">日期</td>
                      <td colspan="1">例会1</td>
                      <td colspan="1">培训2</td>
                      <td colspan="1">实践3</td>
                      <td colspan="1">工作内容4</td>
                    </tr>

                    <tr v-for="(list,b) in itmes" :key="b">
                      <td colspan="1">{{b+1}} 日</td>
                      <td colspan="1">
                        <el-input 
                            v-model.number.trim="list.meetingHour" 
                            type="text" 
                            @input.native="validateNumber($event, 'meetingHour',list)" 
                            placeholder="请输入会议小时数">
                        </el-input>
                    </td>
                    <td colspan="1">
                        <el-input 
                            v-model.number.trim="list.trainHour" 
                            type="text" 
                            @input.native="validateNumber($event, 'trainHour',list)">
                        </el-input>
                    </td>
                    <td colspan="1">
                        <el-input 
                            v-model.number.trim="list.practiceHour" 
                            type="text" 
                            @input.native="validateNumber($event, 'practiceHour',list)">
                        </el-input>
                    </td>
                    <td colspan="1">
                        <el-input 
                            v-model.number.trim="list.workContent" 
                            type="text" 
                            @input.native="validateNumber($event, 'workContent',list)">
                        </el-input>
                    </td>
                    </tr>

                    
                  </table>
                </td>
              </tr>

            </table>
          </div>
          <div class="xuanze2">
            <el-button type="primary" @click="queding">确定</el-button>
          </div>


          <div class="hi">
            <tr>
              <th>工作小组</th>
              <th>工作形式</th>
              <th>1日-6日工作小时数</th>
              <th>7日-13日工作小时数</th>
              <th>14日-20日工作小时数</th>
              <th>21日-27日工作小时数</th>
              <th>28日-月末工作小时数</th>
              <th>本月总小时数</th>
              <th>前期总累计小时</th>
              <th>当前总累计小时</th>
              <th>当前单项总累计</th>
            </tr>
            
            <tr v-for="index in tableData.length * 3 " :key="index">

              <td style="text-align: center; vertical-align: middle !important;" v-if="(index - 1) % 3 === 0"
                :rowspan="3">{{ tableData[Math.floor((index - 1) / 3)].date }} </td>
              <td>{{ tableData[Math.floor((index - 1) / 3)].dataList[(index - 1) % 3].recodeType }}</td>

              <td>
                {{tableData[Math.floor((index - 1) / 3)].dataList[(index - 1) % 3].time1}}
              </td>

              <td>
                {{tableData[Math.floor((index - 1) / 3)].dataList[(index - 1) % 3].time2}}
              </td>

              <td>
                {{tableData[Math.floor((index - 1) / 3)].dataList[(index - 1) % 3].time3}}
              </td>

              <td>
                {{tableData[Math.floor((index - 1) / 3)].dataList[(index - 1) % 3].time4}}
              </td>

              <td>
                {{tableData[Math.floor((index - 1) / 3)].dataList[(index - 1) % 3].time5}}
              </td>

              <td style="text-align: center; vertical-align: middle !important;" v-if="(index - 1) % 3 === 0"
                :rowspan="3">{{ tableData[Math.floor((index - 1) / 3)].totle }}</td>

              <td style="text-align: center; vertical-align: middle !important;" v-if="(index - 1) % 3 === 0"
                :rowspan="3">{{ tableData[Math.floor((index - 1) / 3)].qianqiall }}</td>

              <td style="text-align: center; vertical-align: middle !important;" v-if="(index - 1) % 3 === 0"
                :rowspan="3">{{ tableData[Math.floor((index - 1) / 3)].zongleiji }}</td>

              <td>{{ tableData[Math.floor((index - 1) / 3)].dataList[(index - 1) % 3].time6 }}</td>

            </tr>

            <tr class="tes">
              <td style="line-height: 55px;" colspan="2">本月总累计小时（所有小组小时数相加）</td>
              <td colspan="6">{{ CurTotalTime }}</td>
              <td>例会当前累计</td>
              <td>{{ MeetingTime }}</td>
              <td rowspan="3">-</td>
            </tr>

            <tr class="tes">
              <td style="line-height: 55px;" colspan="2">前期总累计小时数</td>
              <td colspan="6">{{ EarlierTotalTime }}</td>
              <td>培训当前累计</td>
              <td>{{ TrainTime }}</td>
            </tr>

            <tr class="tes">
              <td style="line-height: 55px;" colspan="2">当前总累计小时数</td>
              <td colspan="6">{{ TotalTime }}</td>
              <td>实践当前累计</td>
              <td>{{ PracticeTime }}</td>
            </tr>

          </div>
        </table>
      </el-main>
    </el-container>
  </div>
</template>
<script>

export default {
  data() {
    return {
      pdhave:false,
      alldata:[],
      QqZljlist: '',
      WorkTRecordID: '',
      value1: '2023-11',
      csjkll: true,
      RealName: JSON.parse(sessionStorage.getItem('xinxi')).RealName,
      UserID: JSON.parse(sessionStorage.getItem('xinxi')).UserID,
      options: [],
      value: '',
      formInline: {
        pageSize: "10",
        pageIndex: "1",
        UserName: "",
      },
      Counts: 0,
      currentPage1: 1,
      pageIndexs: 1,
      dialogVisible: false,
      CurTotalTime: 0,//当月总累计小时数
      MeetingTime: 0,//例会总积累小时数
      TrainTime: 0,//培训总累计小时数
      PracticeTime: 0,//实践总累计小时数
      EarlierTotalTime: 0,//前期积累总小时数
      TotalTime: 0,//当前总积累小时数
      tableData: [],
      xiaoshi: [],
      workDetailContents: [
        {
          meetingHour:[{}]
        },
        {
          trainHour:[]
        },
        {
          practiceHour:[]
        },
        {
          workContent:[]
        },
      ],
    }
  },
  methods: {
    selectGet(vId) {
      let obj = {};
      obj = this.options.find((item) => {
        if (vId == item.DropKeyID) {
          this.value1 = item.DropKeyContent;
          return
        }
      });
    },
    chaxun() {
      this.loadings(this.value1);
    },
    queding() {
      var workGroup = []//工作小组中文名
      var meetingHour = []//开会时间
      var trainHour = []//培训时间
      var practiceHour = []//实践时间
      var workContent = []//工作内容
      for(let i in this.options){
        workGroup.push(this.options[i].dropKeyContent)
      }
      for(let i in this.alldata){
        for(let j in this.alldata[i]){
          meetingHour.push(this.alldata[i][j].meetingHour)
          trainHour.push(this.alldata[i][j].trainHour)
          practiceHour.push(this.alldata[i][j].practiceHour)
          workContent.push(this.alldata[i][j].workContent)
        }
      }
      var workDetailContents = {
        workGroup:workGroup,
        meetingHour:meetingHour,
        trainHour:trainHour,
        practiceHour:practiceHour,
        workContent:workContent,
      }
      var k = this.value1.split("-")
      var Vintage = k[0]
      var Month = k[1]
      var ml = {
        vintage: Vintage,
        userID: this.UserID,
        month: Month,
        workDetailContents:workDetailContents
      };
      
      if(this.pdhave){
        this.$Http_Post("/workingtime/updateworkdetails", { from: ml }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.loadings()
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      }else{
        this.$Http_Post("/workingtime/addworkdetails", { from: ml }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.loadings()
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      }
    },
    loadings(time) {
      // alert(this.value1)
      if (time) {
        var k = this.value1.split("-")
        var Vintage = k[0]
        var Month = k[1]
        var from = {
          "userID": this.UserID,
          "name": this.RealName,
          "vintage": Vintage,
          "month": Month
        }
      } else {
        const date = new Date()
        var from = {
          "userID": this.UserID,
          "name": this.RealName,
          "vintage": date.getFullYear(),
          "month": date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`
        }
      }


      this.$Http_Post('workingtime/showworkdetails', { from: from }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
            this.WorkTRecordID = res.Data.workTRecordKey;
            this.csjkll = true;
            this.tableData = res.Data.tableData;
            this.xiaoshi = res.Data.detailsContent;
            this.CurTotalTime = res.Data.curTotalTime;
            this.EarlierTotalTime = res.Data.earlierTotalTime;
            this.MeetingTime = res.Data.meetingTime;
            this.PracticeTime = res.Data.practiceTime;
            this.TotalTime = res.Data.totalTime;
            this.TrainTime = res.Data.trainTime;
            this.alldata = [];
            this.pdhave=res.Data.workTRecordKey?true:false;
            if(res.Data.detailsContents){
              this.alldata = res.Data.detailsContents.map(item => item.showWorkDetailContent);
            }

        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    handleClose(done) {
      this.$confirm('确认关闭？').then(_ => {
        done();
      })
      .catch(_ => {});
    },
    GetData: function () {
      this.tableData.forEach((item) => {
        item.dataList.forEach((cItem) => {
          cItem.hisValue = parseInt(cItem.time6) - parseInt(cItem.time1) - parseInt(cItem.time2) - parseInt(cItem.time3) - parseInt(cItem.time4) - parseInt(cItem.time5);
        })
      })
    },
    validateNumber(event, field, list) {
      if (!event || !event.target) {
        return; // 确保 event.target 存在
      }

      const value = event.target.value;
      const numericValue = value.replace(/[^0-9]/g, ''); // 过滤非数字字符
      list[field] = numericValue ? Number(numericValue) : null; // 更新相应的 v-model 的值
    }
  },
  created: function () {

// User/UpdatePersonalData
    
    var currentTime = new Date();
    var year = currentTime.getFullYear();
    var month = currentTime.getMonth() + 1;

    if(month<10){
      month = '0'+month
    }

  
    this.value1 = year + '-' +month
    this.GetData();
    this.$Http_Post('/workingtime/getdropdownkeylist', { dropKeyType: "WorkGroup", "pageIndex": 1, "pageSize": 10 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
      
        this.options = res.Data;
        for(let item in this.options){
          let a=[{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},{meetingHour:'0',trainHour:'0', practiceHour:'0',workContent:'0'},];
          this.alldata.push(a);
        }
      } else {
        this.Global.request_failure(res.Message);
      }
    })
    this.loadings(this.value1);
  }
}
</script>
<style>
.unul li {width: 100%;text-align: center;height: calc(100% / 3 - 3px);border-bottom: 1px solid #EBEEF5;}
.el-table .cell {padding: 0;}
.Hours_statistics table {width: 100%;background-color: aliceblue;}
.Hours_statistics .hi td,.Hours_statistics .hi th {width: 9%;padding: 0px;line-height: 25px;height: 25px;text-align: center;box-shadow: 1px 1px 1px #000;}
.number-input {width: 100%;}
.tes {height: 60px;}
.details {margin-top: 10px;width: 100%;}
.Hours_statistics .details td,.Hours_statistics .details th {padding: 0px;line-height: 25px;height: 25px;text-align: center;border: rgb(141, 141, 141) 1px solid;}
.Hours_statistics_top {height: 110px;width: 100%;background-color: #fff;}
.Hours_statistics_top .el-form { margin-left: 20px;}
.Hours_statistics_top h2 {width: 98%;height: 50px;line-height: 50px;margin-left: 16px;font-size: 18px;}
.Hours_statistics_top .Activity_post_div {height: 30px;margin-top: 16px;}
.Hours_statistics_top .Activity_post_div span {width: 80px;margin-left: 16px;float: left;}
.Hours_statistics_top .Activity_post_div ul {display: inline-block;float: left;margin-left: -20px;}
.Hours_statistics_top .Activity_post_div li {float: left;margin-left: 20px;}
.Hours_statistics .el-table td,.el-table th {text-align: center;}
.Hours_statistics .hi {border-top: 2px solid;border-left: 2px solid;}
.Hours_statistics .xuanze {margin-top: 20px;}
.Hours_statistics .xuanze button {margin-left: 20px;}
.Hours_statistics .details {border-left: 2px solid;}
.Hours_statistics .xuanze2 button {margin-left: 0px;margin-top: 20px;}
.Hours_statistics {border: 1px solid #e7e7e7;position: relative;height: calc(100% - 2px) !important;overflow: auto;background-color: rgb(235, 236, 237);}
.Hours_statistics .el-header,.CommonContentSingle-white .el-header {background: rgba(255, 255, 255, 1);height: auto !important;padding: 15px;}
.Hours_statistics .el-main,.CommonContentSingle-white .el-main {margin-top: 15px;background: rgba(255, 255, 255, 1);padding: 15px;}
.Hours_statistics .el-form-item,.CommonContentSingle-white .el-form-item {margin-top: 10px !important;margin-bottom: 10px !important;}
.Hours_statistics .el-form-item__error,.CommonContentSingle-white .el-form-item__error {line-height: 40px !important;position: absolute;top: 0px;right: 20px;}
</style>